import React from "react";
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import {
    Icon,
    Button
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
//import MyGlobeIcon from './MyGlobeIcon';

const TopMenuDiv = styled.div`
    position:absolute;
    top:0;
    right:0;
    z-index:999;
    display: flex;
    color:#FFF;
`;
const styles = theme => ({
    flex: {
        flex:1,
        alignSelf:'center',
        background:theme.palette.primary[700],
        borderRadius:0,
        marginLeft:'1rem',
        minWidth: "1rem",
        minHeight: "1rem",
        width: "3rem",
        height: "3rem"
    },
    icon: {
        color: theme.palette.common.white
    }
});

class TopMenu extends React.Component {
    constructor(props) {
        super(props);
        const { classes } = props;
    }
    render() {
        const { classes } = this.props;
        return (
            <TopMenuDiv>
                {/*<MyGlobeIcon />*/}
                <Button
                    color="primary"
                    variant="contained"
                    onClick={this.props.handleMenuClick} 
                    className={this.props.classes.flex}
                >
                    <MenuIcon />
                </Button>
            </TopMenuDiv>
        )
    }
}

export default withStyles(styles)(TopMenu);